import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'

import Container from '@material-ui/core/Container'
import Layout from '../Layout'

import ExtendedPickupHistory from '../../../Component/ExtendedPickupHistory'
import DashboardLayout from '../DashboardLayout'

const TabPanel = ({ children, value, index, ...other }) => {
    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </Typography>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

const ExtendedPickup = (props) => {
    const [value, setValue] = React.useState(0)

    return (
        <>
            <Layout props={props}>
                <div className="GFdashWrapperContainer">
                    <DashboardLayout title="Extended Pickup History">
                        <Container className="db-bids-wrapper mt-4 lq-db-table">
                            <ExtendedPickupHistory />
                        </Container>
                    </DashboardLayout>
                </div>
            </Layout>
        </>
    )
}

export default ExtendedPickup
